define.alias("shared/utils/formatters/tweet-from-dynamo", "media/utils/formatters/tweet-from-dynamo");